import { PageHeader } from '@repo/ui/components/page-header'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { NewCallDialog } from './-components/new-call-dialog'
import { ResidenceCallCard } from './-components/residence-call-card'
import { isCallCreated } from './-lib/steps'
import { managedCallsQueryOptions } from './-query/query-options'

export const Route = createFileRoute('/(private)/bando/')({
	component: CallsPage
})

/**
 * "Bandi": the calls the manager has made, one card each with its state and
 * the next thing to do, those to act on first. "Nuovo bando" makes one on a
 * residence that has none yet.
 */
function CallsPage() {
	const { t } = useTranslation()
	const list = useSuspenseQuery(managedCallsQueryOptions()).data
	// Every call of every residence, with its year. A draft with no dates is a call
	// not made yet, unless the residence has an earlier one: that is the next year's.
	const callsOf = (residenceId: string) =>
		list.filter((item) => item.residence.id === residenceId).length
	const calls = list.filter(
		(item) => isCallCreated(item.call) || callsOf(item.residence.id) > 1
	)
	const free = list.filter(
		(item) => !(calls.includes(item) || isCallCreated(item.call))
	)

	return (
		<main className='flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-4 md:p-6'>
			<PageHeader
				endSlot={<NewCallDialog residences={free} />}
				title={t('admin-call:calls.page_title')}
			/>
			{calls.length === 0 ? (
				<p className='text-muted-foreground text-sm'>
					{t('admin-call:calls.empty')}
				</p>
			) : (
				<ul className='grid gap-4 lg:grid-cols-2'>
					{calls.map((item) => (
						<li key={item.call.id}>
							<ResidenceCallCard item={item} />
						</li>
					))}
				</ul>
			)}
		</main>
	)
}
